import React, { useEffect, useLayoutEffect, useState } from 'react'
import { BsDatabaseFillGear, BsDatabaseFillLock } from 'react-icons/bs'

import { FolderCategories } from '../../api/services/dietbase/types.ts'
import Accordion, { AccordionChildren } from '../../components/common/Accordion'
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'
import TailButton from '../../components/common/TailButton/TailButton.tsx'
import useDietBaseFolders from '../../hooks/useDietBaseFolders.ts'
import Categories from './Categories.tsx'

export const DIET_TAILS = [
  {
    id: 0,
    title: 'Globalna',
    is_global: true
  },
  {
    id: 1,
    title: 'Własna',
    is_global: false
  }
]

const DietBase = () => {
  const { categoryObjects, fetchCategories } = useDietBaseFolders()

  const [baseSelected, setBaseSelected] = React.useState<number | null>(null)
  const [categories, setCategories] = useState<FolderCategories[]>([])
  const [filteredCategories, setFilteredCategories] = useState<
    FolderCategories[] | null
  >(null)
  const [isGlobal, setIsGlobal] = useState<boolean>(false)

  useLayoutEffect(() => {
    if (baseSelected === null) fetchCategories()
  }, [baseSelected])

  useLayoutEffect(() => {
    if (categoryObjects) {
      setCategories(categoryObjects)
    }
  }, [categoryObjects])

  useEffect(() => {
    if (baseSelected !== null) {
      const newFilteredCategories = categories.filter((category) =>
        DIET_TAILS[baseSelected].is_global
          ? category.is_global
          : !category.is_global
      )
      setFilteredCategories(newFilteredCategories)
      setIsGlobal(DIET_TAILS[baseSelected].is_global)
    } else {
      setFilteredCategories(null)
      setIsGlobal(false)
    }
  }, [baseSelected])

  const handleSelect = (props: AccordionChildren) => {
    props.setSqueezed(!props.squeezed)
    props.setLabel(props.newLabel)
  }

  const accordionAction = (squeezed: boolean) => {
    if (!squeezed) setBaseSelected(null)
  }

  return (
    <React.Fragment>
      <Breadcrumbs pageName="Baza diet" breadcrumbs={[]} />

      <Accordion title={'Baza diet'} onSqueezeChange={accordionAction}>
        {({ squeezed, setSqueezed, setLabel, toggleSqueeze }) => (
          <div
            className={
              'flex flex-col md:flex-row items-center flex-wrap gap-4 mt-4'
            }
          >
            {DIET_TAILS.map((tail) => (
              <div key={tail.title}
                onClick={() =>
                  handleSelect({
                    squeezed,
                    setSqueezed,
                    setLabel,
                    newLabel: tail.title,
                    toggleSqueeze
                  })
                }
              >
                <TailButton
                  id={tail.id}
                  title={tail.title}
                  icon={
                    tail.is_global ? (
                      <BsDatabaseFillLock
                        size={40}
                        color={baseSelected === 0 ? '#16a34a' : '#bcbcbc'}
                      />
                    ) : (
                      <BsDatabaseFillGear
                        size={40}
                        color={baseSelected === 1 ? '#16a34a' : '#bcbcbc'}
                      />
                    )
                  }
                  setTailSelected={setBaseSelected}
                  tailSelected={baseSelected}
                  className={'w-50 bg-gray-50  dark:bg-gray-800 rounded'}
                />
              </div>
            ))}
          </div>
        )}
      </Accordion>

      {baseSelected !== null && (
        <Categories
          isGlobal={isGlobal}
          categories={(filteredCategories as FolderCategories[]) ?? []}
        />
      )}
    </React.Fragment>
  )
}

export default DietBase
